import { render, staticRenderFns } from "./table-history.component.vue?vue&type=template&id=7320f21d&scoped=true"
import script from "./table-history.component.vue?vue&type=script&lang=js"
export * from "./table-history.component.vue?vue&type=script&lang=js"
import style0 from "./table-history.component.vue?vue&type=style&index=0&id=7320f21d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320f21d",
  null
  
)

export default component.exports